export default {
  'it-IT': {
    isEmptyTitle: 'Sembra che tu non abbia ancora aggiunto nulla al carrello.',
    isEmptyText: `Puoi cominciare guardando gli <a class="link" href="{latestArrivals}">ultimi arrivi</a>, troverai nuovi prodotti e nuovi brand per chi vuole essere sempre aggiornato.<br>
Oppure preferisci dare un'occhiata ai nostri <a class="link" href="{offers}">prodotti in offerta</a>?<br>
<b>La scelta è tua</b>, il piacere di offrirti il miglior servizio possibile è tutto nostro.<br><br><b>Buoni acquisti su {site}!</b>`,
    cartHeaderTitle: 'Riepilogo carrello',
    amountLeftToFreeShippingCta:
      'Aggiungi {amount} per ottenere la spedizione gratuita!',
    amountLeftToFreeShipping:
      'Spendendo ancora {amount} otterrai gratuitamente la consegna standard.',
    insertCoupon: 'Inserisci un codice sconto',
    appliedCoupon: 'Coupon inserito:',
    applyCoupon: 'Applica Coupon',
    couponApplied: 'Il codice sconto è stato applicato con successo',
    couponNotValid: 'Il codice sconto non è valido',
    articlesNotEligibleForCoupon:
      'Gli articoli nel tuo carrello non sono idonei a sconti',
    productsTotal: 'Totale prodotti',
    productPartialTotal: 'Totale',
    oneItem: '(1 articolo):',
    moreThanOneItem: '({num} articoli):',
    shippingFees: 'Spese di spedizione minime*',
    customFeesEstimate: 'Stima IVA',
    orderTotal: 'Totale ordine',
    includingVAT: '(IVA inclusa)',
    notIncludingVAT: '(IVA esclusa)',
    completePurchase: "Completa l'acquisto",
    shippingFeesInfo:
      '* Le spese di spedizione sono calcolate in base alla nazione selezionata per il trasporto.',
    VATFeesInfo:
      "Per la UE L'IVA è compresa nel prezzo. Vale anche per alcuni stati extra UE (chiaramente indicato)",
    extraUEFeesInfo:
      "Su {site} paghi il totale dell'ordine, eventuali altre spese verranno incassate alla consegna.",
    whatDoesItMean: 'Cosa significa?',
    seeDetails: 'Mostra dettagli',
    hideDetails: 'Nascondi dettagli',
    available: 'disponibile in magazzino',
    booking: 'disponibile in {days} giorni',
    qtyNotAvailable:
      'La quantità selezionata non è disponibile. Scegliere una quantità inferiore.',
    notAvailable: 'Il prodotto o la quantità non è disponibile.',
    someProductsAreNotAvailable:
      "Nel carrello sono presenti articoli non disponibili. Si prega di rimuoverli per poter procedere all'acquisto.",
    someProductsShippingDisallowed:
      'Nel carrello sono presenti articoli non spedibili nella destinazione selezionata. Rimuoverli o cambiare nazione di destinazione.',
    someProductsCourierDisallowed:
      'Nel carrello sono presenti articoli contenenti merce per la quale i servizi di spedizione potrebbero essere limitati per la vostra destinazione (prodotti sotto pressione, batterie, infiammabili, prodotti voluminosi, ecc.). Per accedere ad altri servizi rimuovere tali prodotti.',
    productShippingDisallowed:
      'Il prodotto non può essere spedito nella destinazione selezionata.',
    productCourierDisallowed:
      'Per questo prodotto, i servizi di spedizione potrebbero essere limitati per la destinazione selezionata.',
    understood: 'Ho capito',
    removeLine: {
      remove: 'Rimuovi',
      confirmation: 'Confermi la rimozione del prodotto?',
      cancel: 'Annulla',
    },
    priceChangedToLower:
      'Il prezzo è cambiato da {oldPrice} a {newPrice}.<br/>Risparmi {saving}',
    priceChangedToUpper: 'Il prezzo è cambiato da {oldPrice} a {newPrice}',
  },
  'fr-FR': {
    isEmptyTitle: "Vous n'avez encore ajouté aucun article à votre panier ?",
    isEmptyText: `Commencez par les <a class="link" href="{latestArrivals}">nouveautés</a> ! Vous trouverez tous les nouveaux produits et les nouvelles marques pour suivre les dernières tendances.<br>  
Ou vous préférez peut-être jeter un coup d\'œil à nos <a class="link" href="{offers}">offres</a> ?<br>
<b>C\'est à vous de choisir</b> et à nous d\'offrir le meilleur service possible.<br><br><b>Bon shopping sur {site} !</b>`,
    cartHeaderTitle: 'Récapitulatif du panier',
    amountLeftToFreeShippingCta:
      'Ajoutez {amount} pour bénéficier de la livraison gratuite !',
    amountLeftToFreeShipping:
      'Avec {amount} de plus, vous pourrez bénéficier gratuitement de la livraison standard.',
    insertCoupon: 'Saisir un code de réduction',
    appliedCoupon: 'Coupon inséré :',
    applyCoupon: 'Appliquer le Coupon',
    couponApplied: 'Le code de réduction a été appliqué avec succès',
    couponNotValid: "Le code de réduction n'est pas valable",
    articlesNotEligibleForCoupon:
      'Les articles dans votre panier ne sont pas éligibles à des réductions.',
    productsTotal: 'Total des produits',
    productPartialTotal: 'Total',
    oneItem: '(1 article) :',
    moreThanOneItem: '({num} articles) :',
    shippingFees: 'Frais de livraison minimums*',
    customFeesEstimate: 'Estimation TVA',
    orderTotal: 'Total de la commande',
    includingVAT: '(TVA incluse)',
    notIncludingVAT: '(TVA non incluse)',
    completePurchase: "Finaliser l'achat",
    shippingFeesInfo:
      '* Les frais de port sont calculés en fonction du Pays sélectionné pour le transport.',
    VATFeesInfo:
      "Pour les pays l'UE, la TVA est incluse dans le prix. Elle s'applique également à certains Pays non membres de l'UE (clairement indiqué).",
    extraUEFeesInfo:
      "Sur {site}, vous payez le total de la commande, d'éventuels frais supplémentaires seront perçus à la livraison.",
    whatDoesItMean: "Qu'est-ce que cela signifie ?",
    seeDetails: 'Afficher les détails',
    hideDetails: 'Cacher les détails',
    available: 'disponible en stock',
    booking: 'disponible dans {days} jours',
    qtyNotAvailable:
      "La quantité sélectionnée n'est pas disponible. Veuillez choisir une quantité inférieure.",
    notAvailable: "Le produit ou la quantité n'est pas disponible.",
    someProductsAreNotAvailable:
      "Le panier contient des articles non disponibles. Veuillez les supprimer afin de procéder à l'achat.",
    someProductsShippingDisallowed:
      'Le panier contient des articles qui ne peuvent pas être expédiés vers la destination sélectionnée. Veuillez les supprimer ou modifier le pays de destination.',
    someProductsCourierDisallowed:
      "Votre panier contient des articles pour lesquels les services d'expédition peuvent être limités pour votre destination (produits sous pression, batteries, produits inflammables, produits volumineux, etc.). Veuillez les supprimer pour accéder à d'autres services.",
    productShippingDisallowed:
      'Le produit ne peut pas être expédié à la destination sélectionnée.',
    productCourierDisallowed:
      "Pour ce produit, les services d'expédition peuvent être limités pour la destination sélectionnée.",
    understood: "J'ai compris",
    removeLine: {
      remove: 'Supprimer',
      confirmation: 'Voulez-vous vraiment supprimer ce produit?',
      cancel: 'Annuler',
    },
    priceChangedToLower:
      'Le prix est passé de {oldPrice} à {newPrice}.<br/>Vous économisez {saving}',
    priceChangedToUpper: 'Le prix est passé de {oldPrice} à {newPrice}',
  },
  'es-ES': {
    isEmptyTitle: 'Parece que aún no has añadido nada a tu cesta.',
    isEmptyText: `Si eres de los que quiere estar siempre actualizado, puedes empezar por las <a class="link" href="{latestArrivals}">novedades</a>. Encontrarás lo último en productos y marcas.<br>
¿O tal vez prefieras ojear nuestros <a class="link" href="{offers}">productos en oferta</a>?<br>
<b>La elección es tuya</b>, el placer de ofrecerte el mejor servicio ¡es nuestro!<br><br><b>¡Diviértete comprando en {site}!</b>`,
    cartHeaderTitle: 'Resumen de la cesta de la compra',
    amountLeftToFreeShippingCta:
      '¡Añade {amount} para obtener el envío gratuito!',
    amountLeftToFreeShipping:
      'Si gastas más de {amount} disfrutarás de el envío estándar gratuito.',
    insertCoupon: 'Introduce un código de descuento',
    appliedCoupon: 'Cupón introducido:',
    applyCoupon: 'Aplica Cupón',
    couponApplied: 'El código de descuento se ha aplicado correctamente',
    couponNotValid: 'El código de descuento no es válido',
    articlesNotEligibleForCoupon:
      'Los artículos de su cesta no están sujetos a descuentos',
    productsTotal: 'Total productos',
    productPartialTotal: 'Total',
    oneItem: '(1 artículo):',
    moreThanOneItem: '({num} artículos):',
    shippingFees: 'Gastos mínimos de envío*',
    customFeesEstimate: 'Estimación IVA',
    orderTotal: 'Total pedido',
    includingVAT: '(IVA incluido)',
    notIncludingVAT: '(IVA no incluido)',
    completePurchase: 'Finalizar la compra',
    shippingFeesInfo:
      '* Los gastos de envío se calculan según el país seleccionado para el transporte.',
    VATFeesInfo:
      'Para la UE, el IVA está incluido en el precio. También se aplica a algunos países no pertenecientes a la UE (se indica claramente)',
    extraUEFeesInfo:
      'En {site} pagas el total del pedido, cualquier otro gasto se cobrará en el momento de la entrega.',
    available: 'en stock',
    whatDoesItMean: '¿Qué significa?',
    seeDetails: 'Mostrar detalles',
    hideDetails: 'Ocultar detalles',
    booking: 'disponible en {days} días',
    qtyNotAvailable:
      'La cantidad seleccionada no está disponible. Por favor, elegir una cantidad inferior.',
    notAvailable: 'El producto o la cantidad no están disponibles.',
    someProductsAreNotAvailable:
      'Hay artículos no disponibles en la cesta. Por favor, elimínelos para poder proceder con la compra.',
    someProductsShippingDisallowed:
      'Hay artículos en la cesta que no se pueden enviar al destino seleccionado. Por favor, elimínelos o cambie el país de destino.',
    someProductsCourierDisallowed:
      'Hay artículos en la cesta que contienen bienes para los que los servicios de envío pueden estar limitados en su destino (productos presurizados, baterías, productos inflamables, productos voluminosos, etc.). Por favor, elimine estos productos para acceder a otros servicios de envío.',
    productShippingDisallowed:
      'El producto no puede enviarse al destino seleccionado.',
    productCourierDisallowed:
      'Para este producto, los servicios de envío pueden estar limitados para el destino seleccionado.',
    understood: 'He entendido',
    removeLine: {
      remove: 'Eliminar',
      confirmation: '¿Confirmar cancelación de este producto?',
      cancel: 'Cancelar',
    },
    priceChangedToLower:
      'El precio ha cambiado de {oldPrice} a {newPrice}.<br/>Ahorras {saving}',
    priceChangedToUpper: 'El precio ha cambiado de {oldPrice} a {newPrice}',
  },
  'en-GB': {
    isEmptyTitle: 'It looks like you have not added anything to your cart.',
    isEmptyText: `You can start by looking at the <a class="link" href="{latestArrivals}">latest arrivals</a>, you will be able to find new products and brands for those who want to stay in the trend.<br>  
Or you can take a look at our products we currently have on <a class="link" href="{offers}">offer</a>.<br>
<b>The choice is yours</b>, it is our pleasure to offer you the best possible service.<br><br><b>Enjoy your shopping on {site}!</b>`,
    cartHeaderTitle: 'Cart Summary',
    amountLeftToFreeShippingCta: 'Add {amount} to get free shipping!',
    amountLeftToFreeShipping:
      'Spending {amount} more, you will get free standard delivery.',
    insertCoupon: 'Enter a discount code',
    appliedCoupon: 'Discount code entered:',
    applyCoupon: 'Apply discount code',
    couponApplied: 'The discount code was successfully applied',
    couponNotValid: 'The discount code is not valid',
    articlesNotEligibleForCoupon:
      'Items in your cart are not eligible for discounts',
    productsTotal: 'Products total',
    productPartialTotal: 'Total',
    oneItem: '(1 item):',
    moreThanOneItem: '({num} items):',
    shippingFees: 'Minimum shipping fees*',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: '(Including VAT)',
    notIncludingVAT: '(Excluding VAT)',
    completePurchase: 'Complete the purchase',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    extraUEFeesInfo:
      'On {site} you pay the order total, any other charges will be collected at the time of delivery.',
    whatDoesItMean: 'What does it mean?',
    seeDetails: 'Show details',
    hideDetails: 'Hide details',
    available: 'available',
    booking: 'available in {days} days',
    qtyNotAvailable:
      'The selected quantity is not available. Choose a smaller quantity.',
    notAvailable: 'The product or quantity is not available.',
    someProductsAreNotAvailable:
      'There are unavailable items in the shopping cart. Please remove them in order to proceed with your purchase.',
    someProductsShippingDisallowed:
      'There are items in the shopping cart that cannot be shipped to the selected destination. Please remove them or change destination country.',
    someProductsCourierDisallowed:
      'There are items in your shopping cart that contain goods for which shipping services may be limited for your destination (pressurized products, batteries, flammables, bulky products, etc.). To access other shipping options, please remove those items.',
    productShippingDisallowed:
      'The product cannot be shipped to the selected destination.',
    productCourierDisallowed:
      'For this product, shipping services may be limited for the selected destination.',
    understood: 'I understand',
    removeLine: {
      remove: 'Remove',
      confirmation: 'Confirm the removal of the item?',
      cancel: 'Cancel',
    },
    priceChangedToLower:
      'The price has moved from {oldPrice} to {newPrice}.<br/>You save {saving}',
    priceChangedToUpper: 'The price has moved from {oldPrice} to {newPrice}',
  },
  'en-US': {
    isEmptyTitle: 'It looks like you have not added anything to your cart.',
    isEmptyText: `You can start by looking at the <a class="link" href="{latestArrivals}">latest arrivals</a>, you will be able to find new products and brands for those who want to stay in the trend.<br>  
Or you can take a look at our products we currently have on <a class="link" href="{offers}">offer</a>.<br>
<b>The choice is yours</b>, it is our pleasure to offer you the best possible service.<br><br><b>Enjoy your shopping on {site}!</b>`,
    cartHeaderTitle: 'Cart Summary',
    amountLeftToFreeShippingCta: 'Add {amount} to get free shipping!',
    amountLeftToFreeShipping:
      'Spending {amount} more, you will get free standard delivery.',
    insertCoupon: 'Enter a discount code',
    appliedCoupon: 'Discount code entered:',
    applyCoupon: 'Apply discount code',
    couponApplied: 'The discount code was successfully applied',
    couponNotValid: 'The discount code is not valid',
    articlesNotEligibleForCoupon:
      'Items in your cart are not eligible for discounts',
    productsTotal: 'Products total',
    productPartialTotal: 'Total',
    oneItem: '(1 item):',
    moreThanOneItem: '({num} items):',
    shippingFees: 'Minimum shipping fees*',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: '(Including VAT)',
    notIncludingVAT: '(Excluding VAT)',
    completePurchase: 'Complete the purchase',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    extraUEFeesInfo:
      'On {site} you pay the order total, any other charges will be collected at the time of delivery.',
    whatDoesItMean: 'What does it mean?',
    seeDetails: 'Show details',
    hideDetails: 'Hide details',
    available: 'available',
    booking: 'available in {days} days',
    qtyNotAvailable:
      'The selected quantity is not available. Choose a smaller quantity.',
    notAvailable: 'The product or quantity is not available.',
    someProductsAreNotAvailable:
      'There are unavailable items in the shopping cart. Please remove them in order to proceed with your purchase.',
    someProductsShippingDisallowed:
      'There are items in the shopping cart that cannot be shipped to the selected destination. Please remove them or change destination country.',
    someProductsCourierDisallowed:
      'There are items in your shopping cart that contain goods for which shipping services may be limited for your destination (pressurized products, batteries, flammables, bulky products, etc.). To access other shipping options, please remove those items.',
    productShippingDisallowed:
      'The product cannot be shipped to the selected destination.',
    productCourierDisallowed:
      'For this product, shipping services may be limited for the selected destination.',
    understood: 'I understand',
    removeLine: {
      remove: 'Remove',
      confirmation: 'Confirm the removal of the item?',
      cancel: 'Cancel',
    },
    priceChangedToLower:
      'The price has moved from {oldPrice} to {newPrice}.<br/>You save {saving}',
    priceChangedToUpper: 'The price has moved from {oldPrice} to {newPrice}',
  },
  'de-DE': {
    isEmptyTitle: 'Ihr Warenkorb ist noch leer.',
    isEmptyText: 'Der Warenkorb ist leer. Zum Fortfahren Produkt hinzufügen',
    cartHeaderTitle: 'Warenkorb Zusammenfassung',
    amountLeftToFreeShippingCta:
      'Fügen Sie {amount} hinzu, um kostenlosen Versand zu erhalten!',
    amountLeftToFreeShipping:
      'Wenn Sie {amount} mehr bezahlen, können Sie die kostenlose Standard-Lieferung wählen.',
    insertCoupon: 'Geben Sie einen Rabattcode ein',
    appliedCoupon: 'Rabattcode eingegeben:',
    applyCoupon: 'Rabattcode anwenden',
    couponApplied: 'Der Rabattcode wurde erfolgreich angewendet',
    couponNotValid: 'Der Rabattcode ist nicht gültig',
    articlesNotEligibleForCoupon:
      'Artikel in Ihrem Warenkorb sind von der Rabattierung ausgeschlossen',
    productsTotal: 'Produkte gesamt',
    productPartialTotal: 'Gesamtbetrag',
    oneItem: '(1 Artikel):',
    moreThanOneItem: '({num} Artikel):',
    shippingFees: 'Mindestversandkosten*',
    customFeesEstimate: 'Schätzung MwSt./USt.',
    orderTotal: 'Bestellung gesamt',
    includingVAT: '(Inklusive MwSt.)',
    notIncludingVAT: '(Ohne MwSt.)',
    completePurchase: 'Kauf abschließen',
    shippingFeesInfo:
      '*Die Versandgebühren werden je nach gewähltem Zielland berechnet.',
    VATFeesInfo:
      'Für EU-Länder ist die Mehrwertsteuer im Preis enthalten. Gilt auch für einige Nicht-EU-Länder (deutlich gekennzeichnet)',
    extraUEFeesInfo:
      'Auf {site} bezahlen Sie den Gesamtbetrag der Bestellung, alle anderen Kosten werden bei der Lieferung erhoben.',
    whatDoesItMean: 'Was bedeutet das?',
    seeDetails: 'Details anzeigen',
    hideDetails: 'Details ausblenden',
    available: 'Verfügbar',
    booking: 'verfügbar in {days} Tagen',
    qtyNotAvailable:
      'Die ausgewählte Menge ist nicht verfügbar. Wählen Sie eine kleinere Menge.',
    notAvailable: 'Das Produkt oder die Menge ist nicht verfügbar.',
    someProductsAreNotAvailable:
      'Es befinden sich nicht verfügbare Artikel im Warenkorb. Bitte entfernen Sie diese, um mit Ihrem Kauf fortzufahren.',
    someProductsShippingDisallowed:
      'Es befinden sich Artikel im Warenkorb, die nicht an das ausgewählte Zielland versandt werden können. Bitte entfernen Sie sie oder ändern Sie das Zielland.',
    someProductsCourierDisallowed:
      'In Ihrem Warenkorb befinden sich Artikel, die Produkte enthalten, für die der Versand an Ihren Bestimmungsort möglicherweise eingeschränkt ist (unter Druck stehende Produkte, Batterien, brennbare Stoffe, sperrige Produkte usw.). Um auf andere Kurier-Optionen zuzugreifen, entfernen Sie diese Produkte.',
    productShippingDisallowed:
      'Das Produkt kann nicht zum gewählten Zielland versandt werden.',
    productCourierDisallowed:
      'Für dieses Produkt kann der Versand für den gewählten Zielort eingeschränkt sein.',
    understood: 'Ich verstehe',
    removeLine: {
      remove: 'Entfernen',
      confirmation: 'Bestätigen Sie die Entfernung des Produkts?',
      cancel: 'Abbrechen',
    },
    priceChangedToLower:
      'Der Preis ist von {oldPrice} ins {newPrice} geändert worden.<br/>Sie haben {saving} gespeichert.',
    priceChangedToUpper:
      'Der Preis ist von {oldPrice} ins {newPrice} geändert worden.',
  },
  'en-AU': {
    isEmptyTitle: 'It looks like you have not added anything to your cart.',
    isEmptyText: `You can start by looking at the <a class="link" href="{latestArrivals}">latest arrivals</a>, you will be able to find new products and brands for those who want to stay in the trend.<br>  
Or you can take a look at our products we currently have on <a class="link" href="{offers}">offer</a>.<br>
<b>The choice is yours</b>, it is our pleasure to offer you the best possible service.<br><br><b>Enjoy your shopping on {site}!</b>`,
    cartHeaderTitle: 'Cart Summary',
    amountLeftToFreeShippingCta: 'Add {amount} to get free shipping!',
    amountLeftToFreeShipping:
      'Spending {amount} more, you will get free standard delivery.',
    insertCoupon: 'Enter a discount code',
    appliedCoupon: 'Discount code entered:',
    applyCoupon: 'Apply discount code',
    couponApplied: 'The discount code was successfully applied',
    couponNotValid: 'The discount code is not valid',
    articlesNotEligibleForCoupon:
      'Items in your cart are not eligible for discounts',
    productsTotal: 'Products total',
    productPartialTotal: 'Total',
    oneItem: '(1 item):',
    moreThanOneItem: '({num} items):',
    shippingFees: 'Minimum shipping fees*',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: '(Including VAT)',
    notIncludingVAT: '(Excluding VAT)',
    completePurchase: 'Complete the purchase',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    extraUEFeesInfo:
      'On {site} you pay the order total, any other charges will be collected at the time of delivery.',
    whatDoesItMean: 'What does it mean?',
    seeDetails: 'Show details',
    hideDetails: 'Hide details',
    available: 'available',
    booking: 'available in {days} days',
    qtyNotAvailable:
      'The selected quantity is not available. Choose a smaller quantity.',
    notAvailable: 'The product or quantity is not available.',
    someProductsAreNotAvailable:
      'There are unavailable items in the shopping cart. Please remove them in order to proceed with your purchase.',
    someProductsShippingDisallowed:
      'There are items in the shopping cart that cannot be shipped to the selected destination. Please remove them or change destination country.',
    someProductsCourierDisallowed:
      'There are items in your shopping cart that contain goods for which shipping services may be limited for your destination (pressurized products, batteries, flammables, bulky products, etc.). To access other shipping options, please remove those items.',
    productShippingDisallowed:
      'The product cannot be shipped to the selected destination.',
    productCourierDisallowed:
      'For this product, shipping services may be limited for the selected destination.',
    understood: 'I understand',
    removeLine: {
      remove: 'Remove',
      confirmation: 'Confirm the removal of the item?',
      cancel: 'Cancel',
    },
    priceChangedToLower:
      'The price has moved from {oldPrice} to {newPrice}.<br/>You save {saving}',
    priceChangedToUpper: 'The price has moved from {oldPrice} to {newPrice}',
  },
  'ko-KR': {
    isEmptyTitle: 'It looks like you have not added anything to your cart.',
    isEmptyText: `You can start by looking at the <a class="link" href="{latestArrivals}">latest arrivals</a>, you will be able to find new products and brands for those who want to stay in the trend.<br>  
Or you can take a look at our products we currently have on <a class="link" href="{offers}">offer</a>.<br>
<b>The choice is yours</b>, it is our pleasure to offer you the best possible service.<br><br><b>Enjoy your shopping on {site}!</b>`,
    cartHeaderTitle: 'Cart Summary',
    amountLeftToFreeShippingCta: 'Add {amount} to get free shipping!',
    amountLeftToFreeShipping:
      'Spending {amount} more, you will get free standard delivery.',
    insertCoupon: 'Enter a discount code',
    appliedCoupon: 'Discount code entered:',
    applyCoupon: 'Apply discount code',
    couponApplied: 'The discount code was successfully applied',
    couponNotValid: 'The discount code is not valid',
    articlesNotEligibleForCoupon:
      'Items in your cart are not eligible for discounts',
    productsTotal: 'Products total',
    productPartialTotal: 'Total',
    oneItem: '(1 item):',
    moreThanOneItem: '({num} items):',
    shippingFees: 'Minimum shipping fees*',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: '(Including VAT)',
    notIncludingVAT: '(Excluding VAT)',
    completePurchase: 'Complete the purchase',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    extraUEFeesInfo:
      'On {site} you pay the order total, any other charges will be collected at the time of delivery.',
    whatDoesItMean: 'What does it mean?',
    seeDetails: 'Show details',
    hideDetails: 'Hide details',
    available: 'available',
    booking: 'available in {days} days',
    qtyNotAvailable:
      'The selected quantity is not available. Choose a smaller quantity.',
    notAvailable: 'The product or quantity is not available.',
    someProductsAreNotAvailable:
      'There are unavailable items in the shopping cart. Please remove them in order to proceed with your purchase.',
    someProductsShippingDisallowed:
      'There are items in the shopping cart that cannot be shipped to the selected destination. Please remove them or change destination country.',
    someProductsCourierDisallowed:
      'There are items in your shopping cart that contain goods for which shipping services may be limited for your destination (pressurized products, batteries, flammables, bulky products, etc.). To access other shipping options, please remove those items.',
    productShippingDisallowed:
      'The product cannot be shipped to the selected destination.',
    productCourierDisallowed:
      'For this product, shipping services may be limited for the selected destination.',
    understood: 'I understand',
    removeLine: {
      remove: 'Remove',
      confirmation: 'Confirm the removal of the item?',
      cancel: 'Cancel',
    },
    priceChangedToLower:
      'The price has moved from {oldPrice} to {newPrice}.<br/>You save {saving}',
    priceChangedToUpper: 'The price has moved from {oldPrice} to {newPrice}',
  },
  'jp-JP': {
    isEmptyTitle: 'It looks like you have not added anything to your cart.',
    isEmptyText: `You can start by looking at the <a class="link" href="{latestArrivals}">latest arrivals</a>, you will be able to find new products and brands for those who want to stay in the trend.<br>  
Or you can take a look at our products we currently have on <a class="link" href="{offers}">offer</a>.<br>
<b>The choice is yours</b>, it is our pleasure to offer you the best possible service.<br><br><b>Enjoy your shopping on {site}!</b>`,
    cartHeaderTitle: 'Cart Summary',
    amountLeftToFreeShippingCta: 'Add {amount} to get free shipping!',
    amountLeftToFreeShipping:
      'Spending {amount} more, you will get free standard delivery.',
    insertCoupon: 'Enter a discount code',
    appliedCoupon: 'Discount code entered:',
    applyCoupon: 'Apply discount code',
    couponApplied: 'The discount code was successfully applied',
    couponNotValid: 'The discount code is not valid',
    articlesNotEligibleForCoupon:
      'Items in your cart are not eligible for discounts',
    productsTotal: 'Products total',
    productPartialTotal: 'Total',
    oneItem: '(1 item):',
    moreThanOneItem: '({num} items):',
    shippingFees: 'Minimum shipping fees*',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: '(Including VAT)',
    notIncludingVAT: '(Excluding VAT)',
    completePurchase: 'Complete the purchase',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    extraUEFeesInfo:
      'On {site} you pay the order total, any other charges will be collected at the time of delivery.',
    whatDoesItMean: 'What does it mean?',
    seeDetails: 'Show details',
    hideDetails: 'Hide details',
    available: 'available',
    booking: 'available in {days} days',
    qtyNotAvailable:
      'The selected quantity is not available. Choose a smaller quantity.',
    notAvailable: 'The product or quantity is not available.',
    someProductsAreNotAvailable:
      'There are unavailable items in the shopping cart. Please remove them in order to proceed with your purchase.',
    someProductsShippingDisallowed:
      'There are items in the shopping cart that cannot be shipped to the selected destination. Please remove them or change destination country.',
    someProductsCourierDisallowed:
      'There are items in your shopping cart that contain goods for which shipping services may be limited for your destination (pressurized products, batteries, flammables, bulky products, etc.). To access other shipping options, please remove those items.',
    productShippingDisallowed:
      'The product cannot be shipped to the selected destination.',
    productCourierDisallowed:
      'For this product, shipping services may be limited for the selected destination.',
    understood: 'I understand',
    removeLine: {
      remove: 'Remove',
      confirmation: 'Confirm the removal of the item?',
      cancel: 'Cancel',
    },
    priceChangedToLower:
      'The price has moved from {oldPrice} to {newPrice}.<br/>You save {saving}',
    priceChangedToUpper: 'The price has moved from {oldPrice} to {newPrice}',
  },
};
